import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "./featureInterface";
import UiSwitch from "../../PageLayout/UiSwitch";
import {featuresSetupUpdateFeature} from "../featuresActions";
import SvgIcons from "../../Icons/SvgIcons";
import {getCurrentFeatureToolSettings, isFeatureEnabled} from "../featuresFunctions";
import {AVAILABLE_VISUALIZERS} from "../../../constants/dashboard";


const FeaturesSetupFeatureActionsBottom = (props) => {

  const {feature, featuresSetupUpdateFeature, auth} = props;

  const unlocked = feature.unlinkedData ? feature.unlinkedData.unlocked : feature.unlocked;

  const lockToggle = () => {
    featuresSetupUpdateFeature(feature, "unlocked", !unlocked)
  }

  const checked = isFeatureEnabled(feature, auth);

  const enabledToggle = () => {
    const newValue = !checked;
    const toolSettings = getCurrentFeatureToolSettings(feature);
    Object.values(AVAILABLE_VISUALIZERS).map(subscription => {
      let toolSettingObject = toolSettings.find(toolSetting => toolSetting.tool === subscription);
      if (!toolSettingObject) {
        toolSettingObject = {tool: subscription};
        toolSettings.push(toolSettingObject);
      }
    });
    featuresSetupUpdateFeature(feature, "toolSettings", toolSettings.map(setting => {
      return Object.assign({}, setting, {
        enableQuotingTool: newValue,
        enableVisualizer: newValue,
      })
    }))
    // if (feature.toolSettings && feature.toolSettings.length) {
    //
    // } else {
    //   featuresSetupUpdateFeature(feature, FEATURE_ENABLED_PROPERTIES, FEATURE_ENABLED_PROPERTIES.map(() => newValue))
    // }
  }

  return (
    <div className="fs-feature__actions-cell">
      <div className="fs-feature__action fs-feature__action--bottom">
        <button className={"fs-feature__action-lock" + (unlocked ? " fs-feature__action-lock--unlocked" : "")}
                onClick={lockToggle}>
          {unlocked ? SvgIcons.lockOpen : SvgIcons.lockClosed}
        </button>
      </div>
      <div className="fs-feature__action fs-feature__action--bottom">
        <UiSwitch onClick={enabledToggle}
                  textId={checked ? "checkbox.enabled" : "checkbox.disabled"}
                  checked={checked}/>
      </div>
    </div>
  )
};

FeaturesSetupFeatureActionsBottom.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  return {
    auth: store.auth
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureActionsBottom)
